(function () {
  function measure() {
    var root = document.documentElement;
    var hdr = document.querySelector('.lx .header');
    var ann = document.querySelector('.lx .announcement-bar');
    if (hdr) root.style.setProperty('--header-height', Math.round(hdr.getBoundingClientRect().height) + 'px');
    if (ann) root.style.setProperty('--announcement-bar-height', Math.round(ann.getBoundingClientRect().height) + 'px');
  }
  if (document.readyState !== 'loading') measure();
  else document.addEventListener('DOMContentLoaded', measure);
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);
  document.addEventListener('shopify:section:load', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

  function bind(root) {
    root.querySelectorAll('[data-ai-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var s = btn.closest('.shopify-section') || document;
        s.querySelectorAll('.ai-drawer, .ai-drawer__backdrop').forEach(function (el) {
          el.setAttribute('open-drawer', '');
        });
        document.documentElement.style.overflow = 'hidden';
      });
    });
    root.querySelectorAll('[data-ai-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var s = btn.closest('.shopify-section') || document;
        s.querySelectorAll('.ai-drawer, .ai-drawer__backdrop').forEach(function (el) {
          el.removeAttribute('open-drawer');
        });
        document.documentElement.style.overflow = '';
      });
    });
  }
  if (document.readyState !== 'loading') bind(document);
  else document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();

/* ---- product page: variant picker, quantity, gallery ---- */
(function () {
  function initProduct(root) {
    root.querySelectorAll('[data-ai-product]').forEach(function (prod) {
      if (prod.dataset.aiInit) return;
      prod.dataset.aiInit = '1';

      // the replica reuses the .shopify-section class on its own wrapper, so match the
      // real Shopify section element by id instead
      var section = prod.closest('[id^="shopify-section-"]') || document;
      var dataEl = section.querySelector('[data-ai-product-data]');
      var variants = [];
      if (dataEl) { try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; } }

      var idInput = prod.querySelector('[data-ai-variant-id]');
      var priceEl = prod.querySelector('[data-ai-price]');
      var badgeEl = prod.querySelector('[data-ai-badge]');
      var atc = prod.querySelector('[data-ai-atc]');
      var atcLabel = prod.querySelector('[data-ai-atc-label]');
      var addLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';
      var mediaList = prod.querySelector('[data-ai-media-list]');
      var thumbs = prod.querySelectorAll('[data-ai-thumbs] button');
      var medias = prod.querySelectorAll('.product-gallery__media');

      function showMedia(i) {
        if (!mediaList || !medias.length) return;
        var target = medias[i];
        if (!target) return;
        mediaList.scrollTo({ left: target.offsetLeft - mediaList.offsetLeft, behavior: 'smooth' });
        medias.forEach(function (m, k) { m.classList.toggle('is-selected', k === i); });
        thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }

      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { showMedia(parseInt(b.dataset.index, 10)); });
      });

      prod.querySelectorAll('[data-ai-gallery-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!mediaList || medias.length < 2) return;
          var current = 0;
          var distance = Infinity;
          var left = mediaList.getBoundingClientRect().left;
          medias.forEach(function (media, index) {
            var gap = Math.abs(media.getBoundingClientRect().left - left);
            if (gap < distance) { distance = gap; current = index; }
          });
          showMedia((current + Number(button.dataset.aiGalleryStep) + medias.length) % medias.length);
        });
      });

      prod.querySelectorAll('[data-ai-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = prod.querySelector('.quantity-selector__input');
          if (!input) return;
          var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.aiQty, 10);
          input.value = next < 1 ? 1 : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      var radios = prod.querySelectorAll('[data-ai-variant-picker] input[type=radio]');
      function selectedOptions() {
        var out = [];
        radios.forEach(function (r) {
          if (!r.checked) return;
          out[parseInt(r.dataset.optionPosition, 10) - 1] = r.value;
        });
        return out;
      }
      function update() {
        var chosen = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        prod.querySelectorAll('[data-ai-option-label]').forEach(function (el) {
          var pos = parseInt(el.dataset.aiOptionLabel, 10) - 1;
          if (chosen[pos] != null) el.textContent = chosen[pos];
        });
        if (!match) {
          if (atc) { atc.disabled = true; }
          if (atcLabel) atcLabel.textContent = 'Unavailable';
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = match.price_html || '';
        if (badgeEl) badgeEl.innerHTML = match.badge_html || '';
        if (atc) atc.disabled = !match.available;
        if (atcLabel) atcLabel.textContent = match.available ? addLabel : 'Sold out';
        // Keep the storefront on the product hero; variant media remains available to feeds.
        showMedia(0);
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
    });
  }
  if (document.readyState !== 'loading') initProduct(document);
  else document.addEventListener('DOMContentLoaded', function () { initProduct(document); });
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); });
})();
